const couponItemEndpoints = {
  getCouponItems: "/coupons/getCouponItems",
  getCouponById: "/coupons/:id",
  getUpdateProduct: "/products",
};

export default couponItemEndpoints;
